module.exports = __webpack_public_path__ + "img/xzgpcy.b6123f79.png";